import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loading" }, "loading", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading" }, "loading", -1)

import {
	computed, onUnmounted, watch
} from 'vue'
import {
	NConfigProvider, zhCN, dateZhCN, NLayout, NLayoutHeader, NLayoutContent, NLayoutFooter, NScrollbar, NDialogProvider
} from 'naive-ui'
import HeaderComp from '@/components/HeaderComp.vue'
import FooterComp from '@/components/FooterComp.vue'
import WechatOpenBrowserMask from '@/components/common/WechatOpenBrowserMask.vue'
import getBase from '@/utils/base';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { closeWebSocket, sendWebSocket } from '@/utils/websocket';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { $api, $store } = getBase();
const { locale } = useI18n();
const route = useRoute();
const router = useRouter();
const isBareHash = () =>
	/^#\/(m\/product|mate)(\/.*)?$/.test((window.location.hash || '').split('?')[0]);
const bareLayout = computed(() => $store.getters.isMobile || !!route.meta.bare || isBareHash());
const isProductShowcase = computed(() => {
	const path = route.path || '';
	return path === '/m/product' || path.startsWith('/m/product/') || isBareHash();
});
const isMateH5 = computed(() => {
	const path = route.path || '';
	return path === '/mate' || path.startsWith('/mate/') || /^#\/mate(\/.*)?$/.test((window.location.hash || '').split('?')[0]);
});
const showWechatMask = computed(() => isProductShowcase.value || isMateH5.value);

function connectAlarmWsIfNeeded() {
	const user = $store.state.auth.user;
	if (isMateH5.value) {
		closeWebSocket();
		return;
	}
	if (user && user.id) {
		sendWebSocket("00000000", getAlarmData);
	}
}

watch(() => $store.state.auth.user, () => {
	closeWebSocket();
	connectAlarmWsIfNeeded();
});
watch(isMateH5, () => {
	closeWebSocket();
	connectAlarmWsIfNeeded();
});

// 获取到返回的数据
const getAlarmData = (data: any) => {
	console.log("getAlarmData", data);
}
// 销毁websocket
onUnmounted(() => {
	closeWebSocket();
})

let lang = locale;

const nlocale = computed(() => {
	let result;
	if ('en' == lang.value) {
		result = null;
	} else {
		result = zhCN;
	}
	return result;
});
const ndateLocale = computed(() => {
	let result;
	if ('en' == lang.value) {
		result = null;
	} else {
		result = dateZhCN;
	}
	return result;
});

// 等路由就绪后再决定是否拉权限；公开页不请求 auth，避免未登录提示/跳转
router.isReady().then(() => {
	if (router.currentRoute.value.meta.public) {
		return;
	}
	$api.common.auth().then((res: any) => {
		console.log("auth", res)
		$store.commit('setAuth', res);
	}).catch(() => {
		// 忽略
	});
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(NConfigProvider), {
      locale: _unref(nlocale),
      "date-locale": _unref(ndateLocale)
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NDialogProvider), null, {
          default: _withCtx(() => [
            (!_unref(bareLayout))
              ? (_openBlock(), _createBlock(_unref(NLayout), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NLayoutHeader), null, {
                      default: _withCtx(() => [
                        _createVNode(HeaderComp)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NLayoutContent), { style: {"height":"calc(100vh - 43px - 25px)"} }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NScrollbar), { "x-scrollable": true }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_Suspense, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_view)
                              ]),
                              fallback: _withCtx(() => [
                                _hoisted_1
                              ]),
                              _: 1
                            }))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NLayoutFooter), { style: {"height":"25px"} }, {
                      default: _withCtx(() => [
                        _createVNode(FooterComp)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(NLayout), { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NLayoutContent), { style: {"height":"calc(100vh - 5px)"} }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NScrollbar), null, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_Suspense, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_view)
                              ]),
                              fallback: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            }))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["locale", "date-locale"]),
    (_unref(showWechatMask))
      ? (_openBlock(), _createBlock(WechatOpenBrowserMask, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})